import { createSlice } from '@reduxjs/toolkit';

export const novedadesTurnoSlice = createSlice({
  name: 'novedadesTurno',
  initialState: {
    novedades_turno_list: [],
    novedades_turno: {},
  },
  reducers: {
    setNovedadesTurnoRedux: (state, { payload }) => {
      state.novedades_turno_list = payload;
    },
    storeNovedadesTurnoRedux: (state, { payload }) => {
      state.novedades_turno = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setNovedadesTurnoRedux, storeNovedadesTurnoRedux } = novedadesTurnoSlice.actions;
